import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { AuthorizationServiceProvider } from 'src/app/auth_profile/services/authorization-service.provider';
import { ErrorModalDetails, ErrorModalService } from '../services/error-modal.service';
import { forkJoin, Subscription, switchMap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss',
  standalone: false
})
export class ErrorModalComponent implements OnInit, OnDestroy {

  @ViewChild("errorModal", { static: true })
  errorModal: ModalComponent

  private errorSubscription: Subscription
  error: ErrorModalDetails
  countdown: any
  redirectCountdown: number

  title: string
  message: string

  constructor(
    private authProvider: AuthorizationServiceProvider,
    private errorModalService: ErrorModalService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.errorSubscription = this.errorModalService.error.subscribe(
      error => this.displayErrorModal(error)
    )
  }

  ngOnDestroy(): void {
    this.errorSubscription.unsubscribe()
  }

  displayErrorModal(error: ErrorModalDetails){
    this.error = error

    this.getTranslations()
    if (this.error.timeout && this.error.hasToLogout) {
      this.redirectCountdown = this.error.timeout
      this.countdown = setInterval(() => {
        if (this.redirectCountdown === 0) {
          clearInterval(this.countdown)
          this.errorModal.hide()
          this.logOut()
        }
        else {
          this.redirectCountdown -= 1
          this.translateService.get(this.getMessage(), {sec: this.redirectCountdown})
          .subscribe(value => this.message = value)
        }
      }, 1000)
    } 
    this.errorModal.show(this.isCancellable())
  }

  getTitle() {
    return this.error?.title || ""
  }

  getMessage() {
    return this.error?.message || ""
  }

  isCancellable() {
    return this.error?.cancellable
  }

  logOut() {
    this.authProvider.getCommonRoutines()
      .subscribe(service => service.logout())
  }

  getTranslations() {
    let currentLang = this.translateService.currentLang || this.translateService.getBrowserLang()
    if (currentLang === undefined) return
    
    this.translateService.use(currentLang).pipe(
      switchMap(() => forkJoin([
        this.translateService.get(this.getTitle()),
        this.translateService.get(this.getMessage(), {sec: this.redirectCountdown})
      ]))
    ).subscribe(([title, message]) => {
      this.title = title;
      this.message = message;
    });
  }
}
